import { DocumentFormData } from '../../types/document-form-data';

/** The manual Kundenadresse is the walk-in buyer captured on THIS document, never a
    property of the account (a Barverkauf account pools every walk-in). Picking a
    different customer therefore invalidates it — otherwise the previous buyer's
    address stays on the document, and for a regular customer it would even ship as
    `address.manual = true` although that customer has a master-data address. */
export function clearsManualCustomerAddress(
  previous: { id?: unknown } | null | undefined,
  next: { id?: unknown } | null | undefined
): boolean {
  return (previous?.id ?? null) !== (next?.id ?? null);
}

/** All-or-nothing: clearing single fields would mix two buyers' addresses on one
    document. A Barverkauf customer gets the toggle forced back on with empty,
    required fields. */
export const MANUAL_CUSTOMER_ADDRESS_RESET: Pick<
  DocumentFormData,
  'manualCustomerAddressEnabled' | 'manualAddressValue'
> = {
  manualCustomerAddressEnabled: false,
  manualAddressValue: null,
};
